import './instagram_dm_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.InstagramImageDMContent extends Monitoring.Models.SocialContents.InstagramDMContent

  getMainText: ->
    image_versions = @data.content?.media?.image_versions2?.candidates
    if image_versions.length > 0
      image_versions[0].url
    else
      "Image not found"
